export default __webpack_public_path__ + "static/MediaContentTwo-4787b8ba07c67cf965fe8d84204a092d.webp";